import './tab-content.css';
export default {
  "modifiers": {
    "secondary": "pf-m-secondary",
    "padding": "pf-m-padding"
  },
  "tabContent": "pf-v6-c-tab-content",
  "tabContentBody": "pf-v6-c-tab-content__body"
};